// extracted by mini-css-extract-plugin
module.exports = {"Container":"View_Container__2A0WJ","Loading":"View_Loading__339rw","NotAuthorized":"View_NotAuthorized__2mbBK","Dashboard":"View_Dashboard__1Pp07"};